// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
// orignal code: start
// document.addEventListener("cart:updated", function (evt) {
//   console.log("Cart updated");
//   console.log(evt.detail.cart);
// });
// orignal code: end


document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
  if(evt.detail.cart.sections && document.body.classList.contains("page-payment-plan")) {
    const parser = new DOMParser();
    const newHtml = parser.parseFromString(
      evt.detail.cart.sections["installment-payment-section"],
      "text/html"
    );

    const newSection = newHtml.querySelector("#shopify-section-installment-payment-section");
    const currentSection = document.querySelector("#shopify-section-installment-payment-section");
    
    if (newSection && currentSection) {
      if (newSection.querySelector("[data-cart-total-custom]") && newSection.querySelector("[data-cart-subtotal]")) {
        document.querySelectorAll("[data-cart-total-custom]").forEach(item => item.setAttribute("data-cart-total-custom", newSection.querySelector("[data-cart-total-custom]").dataset.cartTotalCustom));
        document.querySelectorAll("[data-cart-subtotal]").forEach(item => item.setAttribute("data-cart-subtotal", newSection.querySelector("[data-cart-subtotal]").dataset.cartSubtotal));
      }
      currentSection.replaceWith(newSection);
      if(evt.detail.cart.discount_codes.length > 0){
        const discountTagContainer = document.querySelector("#discount-tags");
        // Check if there are any discount codes applied
        const discountCodes = evt.detail.cart.discount_codes.filter(discount => discount.applicable) || [];
        
        // Clear any existing discount tags in the container before adding new ones
        discountTagContainer.innerHTML = '';
        
        // Add each discount code as a tag
        discountCodes.forEach(discount => {
          const discountTag = document.createElement('div');
          discountTag.classList.add('discount-tag');
          discountTag.setAttribute("dicount-code", discount.code);
          discountTag.textContent = discount.code;

          // Add remove functionality to the tag
          const removeTagBtn = document.createElement('button');
          removeTagBtn.classList.add('remove-tag-btn');
          removeTagBtn.textContent = '×'; // Unicode for 'X' symbol (better for accessibility)

          removeTagBtn.onclick = () => removeDiscountTag(discount.code, removeTagBtn); // Call remove function with code

          discountTag.appendChild(removeTagBtn);
          discountTagContainer.appendChild(discountTag);
        });
      }
      console.log("section Updated");
    }
  }
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});
